module.exports = __webpack_public_path__ + "static/media/b6.56b236b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/suchunyuan/b6.mp3
// module id = t3lR
// module chunks = 0